/* Matches the automatic Buy 2, get 1 free collection discount, with no per-order limit.
 * Prices stay in Shopify's integer currency units. Checkout applies the final discount.
 */
(() => {
  function summarize(items) {
    const selected = items.filter(item => Number.isInteger(item.quantity) && item.quantity > 0);
    const count = selected.reduce((sum, item) => sum + item.quantity, 0);
    const subtotal = selected.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const freeCount = Math.floor(count / 3);
    let remaining = freeCount;
    let discount = 0;
    for (const item of [...selected].sort((a, b) => a.price - b.price)) {
      const free = Math.min(remaining, item.quantity);
      discount += free * item.price;
      remaining -= free;
      if (!remaining) break;
    }
    const target = Math.max(3, Math.ceil(count / 3) * 3);
    const missing = Math.max(0, 2 - count);
    let message = `${count} ${count === 1 ? 'flaske' : 'flasker'} valgt.`;
    if (missing) message += ` Vælg ${missing} ${missing === 1 ? 'flaske' : 'flasker'} mere til sættet.`;
    else {
      if (freeCount) message += ` ${freeCount} ${freeCount === 1 ? 'flaske' : 'flasker'} gratis.`;
      if (count % 3) {
        const next = target - count;
        message += ` Tilføj ${next} mere, og få ${freeCount ? 'endnu en flaske' : 'den ene'} gratis.`;
      }
    }
    return { count, subtotal, freeCount, discount, total: subtotal - discount, target, missing, message };
  }
  window.KluvBundlePricing = Object.freeze({ summarize });
})();
